import * as Yup from 'yup'

export const ratingSettingsSchema = Yup.object().shape({
  name: Yup.string().max(16, 'validation-name-max').required('validation-required'),
  min_points: Yup.number().typeError('validation-number-required').required('validation-required'),
})
